import styled from "styled-components";
import { FaTrophy, FaEdit, FaTrashAlt } from "react-icons/fa";

/* =======================
   LAYOUT GERAL
======================= */

export const PageLayout = styled.div`
  display: flex;
  width: 100%;
  min-height: 100vh;
  background-color: #f9fafb;
`;

export const Container = styled.main`
  flex: 1;
  padding: 2rem;
  background-color: #f9fafb;
  font-family: "Inter", sans-serif;
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 1.5rem;
`;

export const Title = styled.h1`
  font-size: 30px;
  font-weight: 700;
  color: #111827;
`;

export const Subtitle = styled.p`
  margin-top: 6px;
  color: #6b7280;
  font-size: 16px;
`;

export const AddButton = styled.button`
  background-color: #2563eb;
  color: #fff;
  font-weight: 500;
  border: none;
  display: flex;
  align-items: center;
  gap: 0.4rem;
  padding: 0.65rem 1rem;
  border-radius: 0.5rem;
  cursor: pointer;
  transition: 0.2s ease;

  &:hover {
    background-color: #1e4ed8;
  }
`;

/* =======================
   FILTRO / BUSCA
======================= */

export const SearchWrapper = styled.div`
  position: relative;
  margin-bottom: 1.5rem;
`;

export const SearchInput = styled.input`
  width: 100%;
  height: 45px;
  padding-left: 1rem;
  padding-right: 1rem;
  border: 1px solid #d1d5db;
  border-radius: 0.5rem;
  font-size: 0.95rem;
  color: #374151;

  &:focus {
    outline: none;
    border-color: #2563eb;
    box-shadow: 0 0 0 2px rgba(37, 99, 235, 0.12);
  }
`;

export const SortWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-bottom: 1.2rem;

  label {
    font-size: 0.95rem;
    font-weight: 600;
    color: #374151;
  }

  select {
    padding: 0.45rem 0.8rem;
    border-radius: 0.5rem;
    border: 1px solid #d1d5db;
    font-size: 0.9rem;
    cursor: pointer;
    background: white;
  }
`;

/* =======================
   GRID DE CONQUISTAS
======================= */

export const AchievementsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 1.5rem;
`;

/* =======================
   CARD DA CONQUISTA
======================= */

export const AchievementCard = styled.div`
  background-color: #ffffff;
  border-radius: 14px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 14px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  transition: 0.2s ease;

  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.08);
  }
`;

export const AchievementHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
`;

export const AchievementIconWrapper = styled.div`
  background-color: #fff7ed;
  padding: 12px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const AchievementIcon = styled(FaTrophy)`
  color: #f59e0b;
  font-size: 28px;
`;

export const AchievementActions = styled.div`
  display: flex;
  gap: 10px;
`;

export const EditIcon = styled(FaEdit)`
  color: #94a3b8;
  cursor: pointer;

  &:hover {
    color: #475569;
  }
`;

export const DeleteIcon = styled(FaTrashAlt)`
  color: #94a3b8;
  cursor: pointer;

  &:hover {
    color: #dc2626;
  }
`;

export const AchievementTitle = styled.h3`
  font-size: 1.1rem;
  font-weight: 600;
  color: #1f2937;
  margin: 0;
`;

export const AchievementDescription = styled.p`
  font-size: 0.95rem;
  color: #6b7280;
  line-height: 1.5;
  margin: 0;
`;

export const AchievementTag = styled.span`
  align-self: flex-start;
  background-color: #ecfeff;
  color: #0f766e;
  font-size: 0.75rem;
  font-weight: 600;
  padding: 4px 10px;
  border-radius: 999px;
`;

/* =======================
   MODAL
======================= */

export const ModalOverlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

export const ModalContent = styled.div`
  background: #fff;
  border-radius: 12px;
  max-width: 650px;
  width: 92%;
  max-height: 85vh;
  overflow: hidden;
  position: relative;
  display: flex;
  flex-direction: column;
`;

export const ModalImageHeader = styled.div`
  height: 300px;
  background: #f3f4f6;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

export const ModalCloseButton = styled.button`
  position: absolute;
  top: 12px;
  right: 12px;
  background: rgba(0, 0, 0, 0.55);
  border: none;
  width: 34px;
  height: 34px;
  border-radius: 50%;
  color: white;
  cursor: pointer;

  &:hover {
    background: rgba(0, 0, 0, 0.8);
  }
`;

export const ModalSection = styled.div`
  padding: 1.25rem;
  border-top: 1px solid #e5e7eb;
`;

export const ModalTag = styled.span`
  background-color: #f3e8ff;
  color: #7e22ce;
  font-size: 0.8rem;
  font-weight: 500;
  padding: 4px 10px;
  border-radius: 9999px;
`;

export const StatusBadge = styled.span`
  display: inline-flex;
  align-items: center;
  height: fit-content;

  padding: 4px 10px;
  border-radius: 999px;
  font-size: 0.7rem;
  font-weight: 600;
  white-space: nowrap;

  background-color: ${(props) =>
    props.children === "Ativa" ? "#dcfce7" : "#fee2e2"};

  color: ${(props) =>
    props.children === "Ativa" ? "#166534" : "#991b1b"};
`;
